import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUsermagblack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 11,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "#2B2B2B",
		fillRule: "nonzero",
		children: /* @__PURE__ */ _jsx("path", { d: "M8 4c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2zM13 5c-.898 0-1.724.368-2.287.984A4.157 4.157 0 0 0 8 5a4.136 4.136 0 0 0-2.713.986C4.684 5.324 3.856 5 3 5 1.716 5 .618 5.748.19 6.798a2.57 2.57 0 0 0-.19.971v1.846c0 .256.224.462.5.462H4v.461c0 .256.224.462.5.462h7c.276 0 .5-.206.5-.462v-.461h3.5c.276 0 .5-.206.5-.462V7.77C16 6.24 14.662 5 13 5zm-2 5.077H5V8.692C5 7.21 6.294 5.923 8 5.923c1.695 0 3 1.277 3 2.77v1.384zM13 4c1.103 0 2-.897 2-2s-.897-2-2-2c-1.102 0-2 .897-2 2s.898 2 2 2zM3 4c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2z" })
	})
});
export default SvgUsermagblack;
